import React from 'react';

import { useState } from 'react';
import './index.css'
import { GetAsset, AddAsset, ConsumeAsset } from './Asset';
import { Login, SubmitScore, ChangeUser, GenerateSeason }  from './Game'
import { RecoverPW, RegisterMail, LinkWallet, SetPW, CheckMailVerified } from './User';

import { Encryptme } from '../Encryptme'

export function Encryptform() {

	const [activeForm,setActiveForm] = useState("game_main")

	const determineClassName = (target) => {
		const category = activeForm.substring(0,activeForm.indexOf('_'))
		//handle category buttons first
		if (target.startsWith('category') & target.endsWith(category))
				return target + " active"
		else if (target.startsWith('category'))
				return target
		//handle details button		
		if (activeForm === target)
			return target + " active"
		else if (target.startsWith(category))
			return target
		else
			return "hidden"
	}

	return (
		<div className="APITabs">
			<ul className="nav1">
				<li className={determineClassName('category_encrypt')} onClick={() =>setActiveForm('encrypt_encrypt')}>Encryption</li>
				<li className={determineClassName('category_game')} onClick={() =>setActiveForm('game_main')}>Game endpoint</li>
				<li className={determineClassName('category_user')} onClick={() =>setActiveForm('user_main')}>User</li>
				<li className={determineClassName('category_ast')} onClick={() =>setActiveForm('ast_tab1')}>Asset endpoint</li>
				<li className={determineClassName('category_season')} onClick={() =>setActiveForm('season_main')}>Seasons</li>
			</ul>
			<div className="outlet">
				{activeForm === "game_main" ? <><Login /><SubmitScore /><ChangeUser /> </> : ""}
				{activeForm === "ast_tab1" ? <><GetAsset /> <AddAsset /> <ConsumeAsset /></>: ""}
				{activeForm === "encrypt_encrypt" ? <Encryptme />: ""}
				{activeForm === "user_main" ? <><RegisterMail /><LinkWallet /><RecoverPW /><SetPW /><CheckMailVerified /></>: ""}
				{activeForm === "season_main" ? <><GenerateSeason /></>: ""}
				
			</div>
		</div>
	);

};